<template><main class="terrain-public-access"><section><h1>Abriendo invitación</h1><p v-if="loading">Validando acceso…</p><p v-else role="alert">{{ errorMessage }}</p></section></main></template>
<script>
import { createTerrainApi } from "../../services/terrain/api.js";
export default {
  name: "TerrainInvitationExchange",
  data: () => ({ loading: true, errorMessage: "" }),
  computed: { terrainApi() { return createTerrainApi(this.$http, this.$store.getters.backendurl); } },
  created() { this.exchange(); },
  methods: {
    async exchange() {
      try {
        const token = this.$route.query.token;
        const response = await this.terrainApi.exchangeInvitation(token);
        const data = response.data || {};
        this.$router.replace(data.responseId
          ? { name: "terrain-response-correction", params: { campaignId: data.campaignId, responseId: data.responseId } }
          : { name: "terrain-campaign-form", params: { campaignId: data.campaignId } });
      } catch (error) { this.errorMessage = "La invitación no es válida o ya no está disponible."; this.loading = false; }
    },
  },
};
</script>
<style scoped>.terrain-public-access { min-height: 100vh; padding: 3rem; text-align: center; }</style>
